// ---------------------------------------------------------------------------
// YouAreYou (uru) — Mode Provider
//
// Provides Simple / Advanced mode state to the entire app.
// Default is "simple". Persists to localStorage.
// ---------------------------------------------------------------------------

import { useEffect, useState, type ReactNode } from "react";
import { ModeContext, MODE_STORAGE_KEY, type AppMode } from "@/context/modeTypes";

export function ModeProvider({ children }: { children: ReactNode }) {
  const [mode, setModeState] = useState<AppMode>(() => {
    const stored = localStorage.getItem(MODE_STORAGE_KEY);
    return stored === "advanced" ? "advanced" : "simple";
  });

  useEffect(() => {
    localStorage.setItem(MODE_STORAGE_KEY, mode);
  }, [mode]);

  function setMode(next: AppMode) {
    setModeState(next);
  }

  function toggleMode() {
    setModeState((m) => (m === "simple" ? "advanced" : "simple"));
  }

  return (
    <ModeContext.Provider value={{ mode, setMode, toggleMode }}>
      {children}
    </ModeContext.Provider>
  );
}
